import userService from "../../../services/user.service";

async function getDoctorRanks() {
  try {
    const response = await userService.getDoctorRank(-1, 0, "");
    if (response.data && response.data.status) {
      console.log(response.data.result);
      return JSON.stringify(response.data.result);
    } else {
      return (
        JSON.stringify(response.data.message) || "Failed to fetch doctor ranks."
      );
    }
  } catch (error) {
    const errorMessage =
      (error.response && error.response.data && error.response.data.message) ||
      error.message ||
      "An unexpected error occurred.";
    console.error("Error fetching doctor ranks:", errorMessage);
    return JSON.stringify(errorMessage);
  }
}

async function addDoctorRankToDatabase({
  rankName,
  rankDescription,
  isActive,
}) {
  try {
    const payload = {
      name: rankName,
      description: rankDescription,
      active: isActive,
    };
    const response = await userService.addDoctorRank(payload);
    if (response.data && response.data.status) {
      console.log(response.data.result);
      return JSON.stringify(response.data.result);
    } else {
      return (
        JSON.stringify(response.data.message) ||
        "Failed to add doctor rank."
      );
    }
  } catch (error) {
    const errorMessage =
      (error.response && error.response.data && error.response.data.message) ||
      error.message ||
      "An unexpected error occurred.";
    console.error("Error adding doctor rank:", errorMessage);
    return JSON.stringify(errorMessage);
  }
}

async function updateDoctorRankInDatabase({
  rankId,
  rankName,
  rankDescription,
  isActive,
}) {
  try {
    const payload = {
      id: rankId,
      name: rankName,
      description: rankDescription,
      active: isActive,
    };
    const response = await userService.updateDoctorRank(payload);
    if (response.data && response.data.status) {
      console.log(response.data.result);
      return JSON.stringify(response.data.result);
    } else {
      return (
        JSON.stringify(response.data.message) || "Failed to update doctor rank."
      );
    }
  } catch (error) {
    const errorMessage =
      (error.response && error.response.data && error.response.data.message) ||
      error.message ||
      "An unexpected error occurred.";
    console.error("Error updating doctor rank:", errorMessage);
    return JSON.stringify(errorMessage);
  }
}

export default {
  addDoctorRankToDatabase,
  getDoctorRanks,
  updateDoctorRankInDatabase,
  doctorRankTools: [
    {
      type: "function",
      function: {
        name: "getDoctorRanks",
        description:
          "Fetch all doctor ranks from the database. You must return all ranks without skipping any data unless instructed otherwise.",
        parameters: {
          type: "object",
          properties: {},
        },
      },
    },
    {
      type: "function",
      function: {
        name: "updateDoctorRankInDatabase",
        description: "Update an existing doctor rank in the database",
        parameters: {
          type: "object",
          properties: {
            rankId: {
              type: "string",
              description: "The unique ID of the rank to be updated",
            },
            rankName: {
              type: "string",
              description: "Name of the rank",
            },
            rankDescription: {
              type: "string",
              description: "Description of the rank",
            },
            isActive: {
              type: "boolean",
              description: "Whether the rank is active or not",
            },
          },
          required: [
            "rankId",
            "rankName",
            "rankDescription",
          ],
        },
      },
    },
    {
      type: "function",
      function: {
        name: "addDoctorRankToDatabase",
        description: "Add a doctor rank to the database",
        parameters: {
          type: "object",
          properties: {
            rankName: {
              type: "string",
              description: "Name of the rank",
            },
            rankDescription: {
              type: "string",
              description: "Description of the rank",
            },
            isActive: {
              type: "boolean",
              description: "Whether the rank is active or not",
            },
          },
          required: [
            "rankName",
            "shortName",
            "rankDescription",
          ],
        },
      },
    },
  ],
};
